<script lang="ts">
	//Components
	import AddEditGroupWizard from '../../Groups/GroupWizard/AddEditGroupWizard.svelte';
	//Helpers
	import { _deepClone } from '../../../helpers/utilities';
	import { defaultGroupObject } from 'src/helpers/group_helpers';
	import type { Group } from 'src/types/Group';

	export let showModal: boolean;
	export let routeParams: {
		type: string;
		id: string;
	};

	let editGroup = {
		...(_deepClone(defaultGroupObject) as Group),
		...(routeParams?.type === 'room' && { room_id: +routeParams?.id }),
	};
</script>

<!-- Add/Edit Group Modal -->
<AddEditGroupWizard {editGroup} bind:showAddEditGroupModal={showModal} on:close />
